import {
  AORIGEM_OS_MANUT_AUTOMATICA,
  AORIGEM_OS_MANUT_IMPORTADO,
  AORIGEM_OS_MANUT_MANUAL,
  AOS_MANUT_VEICULO_ABERTA,
  AOS_MANUT_VEICULO_CANCELADA,
  AOS_MANUT_VEICULO_FECHADA,
  ASIM
} from 'consts';

/* Salva as configurações no sessionStorage */
export const saveConfigurations = (configurations, nameConfiguration) => {
  sessionStorage.setItem(nameConfiguration, JSON.stringify(configurations));
};

/* Carrega as configurações armazenadas no sessionStorage */
export const loadConfigurations = (nameConfiguration) => {
  const storedConfigs = sessionStorage.getItem(nameConfiguration);

  if (storedConfigs) {
    return JSON.parse(storedConfigs);
  }

  return null;
};

/* Pega a informação da configuração específica */
export const getConfigField = (field, nameConfiguration = 'cfg') => {
  const configs = loadConfigurations(nameConfiguration);

  if (configs && typeof configs === 'object') {
    return configs[field];
  }

  return null;
};

/* Salva a empresa no sessionStorage */
export const saveCompany = (company) => {
  sessionStorage.setItem('empresa', JSON.stringify(company));
};

/* Carrega a empresa armazenada no sessionStorage */
export const loadCompany = () => {
  const storedCompany = sessionStorage.getItem('empresa');

  if (storedCompany) {
    return JSON.parse(storedCompany);
  }

  return null;
};

/* Pega a informação específica da empresa */
export const getCompanyField = (field) => {
  const company = loadCompany();

  if (company && typeof company === 'object') {
    return company[field];
  }

  return null;
};

/* Carrega o PDV armazenado no sessionStorage */
export const loadPDV = () => {
  const storedPDV = sessionStorage.getItem('pdv');

  if (storedPDV) {
    return JSON.parse(storedPDV);
  }

  return null;
};

/* Salva o PDV no sessionStorage */
export const savePDV = (pdv) => {
  sessionStorage.setItem('pdv', JSON.stringify(pdv));
};

/* Pega o campo específico do PDV */
export const getPDVField = (field) => {
  const pdv = loadPDV();

  if (pdv && typeof pdv === 'object') {
    return pdv[field];
  }

  return null;
};

/* Retorna o estado da situação de OS de manutenção de veículo */
export const getSituacaoOsManut = (situacao) => {
  switch (situacao) {
    case AOS_MANUT_VEICULO_ABERTA: return 'aberta';
    case AOS_MANUT_VEICULO_FECHADA: return 'encerrada';
    case AOS_MANUT_VEICULO_CANCELADA: return 'cancelada';

    default: return 'nova';
  }
};

/* Retorna a cor conforme o estado da situação de OS de manutenção de veículo */
export const getSituacaoOsManutColor = (situacao) => {
  switch (situacao) {
    case AOS_MANUT_VEICULO_ABERTA: return '#1660b5';
    case AOS_MANUT_VEICULO_FECHADA: return '#616161';
    case AOS_MANUT_VEICULO_CANCELADA: return '#d32f2f';

    default: return '#3a913f';
  }
};

/* Retorna a descrição da origem da OS de manutenção de veículo */
export const getOrigemOsManut = (origem) => {
  const origemOS = Number(origem ?? AORIGEM_OS_MANUT_MANUAL);

  if (origemOS === AORIGEM_OS_MANUT_IMPORTADO) return 'importado';
  if (origemOS === AORIGEM_OS_MANUT_AUTOMATICA) return 'automática';

  return 'manual';
};

/* Invalida os valores nulos, vazios ou indefinidos */
export const isInvalidSelect = (value) => {
  return (
    value === null ||
    value === undefined ||
    value === '' ||
    value === 0 ||
    value === '0'
  );
};

/* Valida os campos ComboPadrao */
export const validateComboFields = (
  data = {},
  comboFields = []
) => {
  const comboErrors = {};

  comboFields.forEach(({ field, message }) => {
    if (isInvalidSelect(data[field])) {
      comboErrors[field] = message;
    }
  });

  return comboErrors;
};

/* Verifica se uma flag S/N retornada do banco está ativa */
export const isFlagAtiva = (item = {}, field) => {
  const value = item[field] ?? item[field.toUpperCase()];

  return String(value ?? '').trim().toUpperCase() === ASIM;
};